<template>
  <section class="section-201 p-0 m-0 col-12">
    <m-img v-if=" mediaType === 'image' " :src="image" class="section-201-image" :alt="alt"/>
    <video v-else class="section-201-video" :muted="muted" :autoplay="autoplay" :loop="loop">
      <source :src="videoSrc" type="video/mp4"/>
      Your browser does not support the video tag.
    </video>
    <div class="top-1">
      <slot name="top-1"></slot>
    </div>
    <div class="top-2">
      <slot name="top-2"></slot>
    </div>
    <div class="top-3">
      <slot name="top-3"></slot>
    </div>
    <div class="mid-1">
      <slot name="mid-1"></slot>
    </div>
    <div class="mid-2">
      <slot name="mid-2"></slot>
    </div>
    <div class="mid-3">
      <slot name="mid-3"></slot>
    </div>
    <div class="bottom-1">
      <slot name="bottom-1"></slot>
    </div>
    <div class="bottom-2">
      <slot name="bottom-2"></slot>
    </div>
    <div class="bottom-3">
      <slot name="bottom-3"></slot>
    </div>
  </section>
</template>

<script>
import mImg from "../Tags/Img";
import {videoProps} from "../Tags/VideoProps";

export default {
  name: "Section201",
  components: {
    mImg,
  },
  props: {
    mediaType: {
      default: 'image',
      options: ['video', 'image'],
    },
    image: {
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      default: 'mix it web'
    },
    ...videoProps,
  },
}
</script>

<style scoped>
.section-201 {
  position: relative;
  text-align: center;
  color: white;
  width: 100%;
  overflow: hidden;
}


.section-201-image {
  z-index: -1;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
}

.section-201-video {
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover !important;
}

.top-1 {
  position: absolute;
  top: 8px;
  right: 0;
}

.top-2 {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.top-3 {
  position: absolute;
  top: 8px;
  left: 0;
}

.mid-1 {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-0%, -50%);
}

.mid-2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.mid-3 {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
}

.bottom-1 {
  position: absolute;
  bottom: 1px;
  right: 0;
}

.bottom-2 {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bottom-3 {
  position: absolute;
  bottom: 1px;
  left: 0;
}
</style>